import { useEffect } from 'react';
import Navbar from '../Components/navbar'
import SC1 from '../images/sc1.png'
import SC2 from '../images/sc2.png'
import SC3 from '../images/sc3.png'
import SC4 from '../images/sc4.png'
import SC5 from '../images/sc5.png'
import SC6 from '../images/sc6.png'
import SC7 from '../images/sc7.png'
import SC8 from '../images/sc8.png'
import SC9 from '../images/sc9.png'
import SC10 from '../images/sc10.png'
import SC11 from '../images/sc11.png'
import SC12 from '../images/sc12.png'
import SC13 from '../images/sc13.png'
import SC14 from '../images/sc14.png'
import SC15 from '../images/sc15.png'
import SC16 from '../images/sc16.png'
import SC17 from '../images/sc17.png'
import Footer from '../Components/Footer';

import '../Pages/Gallery.css'
export default function Gallery() {

useEffect(() => {
       window.scrollTo(0, 0); // Scroll to the top of the page
     }, []);


  return (
    <>
    
    <Navbar/>


<section id='gal'>

  <div className='container'>
      <div className='row'>


<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC1} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC2} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC3} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC4} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC5} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC6} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC7} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC8} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC9} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC10} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC11} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC12} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC13} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC14} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC15} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC16} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>
<div className='col-lg-4 col-md-4 col-sm-12 col-12'>
<img src={SC17} alt='OM Enterprises' title='OM Enterprises' className='img-fluid'/>

</div>

    </div>
  </div>




</section>



    <Footer/>
    
    
    </>
  )
}
